<template>
  <router-link
    :to="{ name: game }"
    class="button-back"
    id="pad-back"
    pad-up="go:#pad-home"
    pad-left="go:.swiper-slide-active a"
    pad-a="click"
  >
    <iconArrowBack />
  </router-link>
</template>

<script>
import { mapState } from "vuex";
import iconArrowBack from "@/components/Icons/iconArrowBack.vue";

export default {
  components: {
    iconArrowBack
  },
  computed: {
    ...mapState({
      game: state => state.game
    })
  }
};
</script>

<style lang="scss" scoped>
.button-back {
  background: $yellow;
  width: 4.5vw;
  height: 4vw;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}
</style>
